import { orderKey, type AnyDomainEvent } from '@abastece/shared';
import type { ApplyResult, Reader } from '../state.js';

/**
 * Sign-ins and wrong PINs.
 *
 * Mostly for the bitácora. A sign-in also says who is using the device it happened on, which is
 * the only device a device's token can speak for: the owner's decisions are taken only from a
 * device the owner is using (`permisos.ts`). A wrong PIN changes nothing.
 */
export async function reduceSesion(event: AnyDomainEvent, read: Reader): Promise<ApplyResult | null> {
  switch (event.type) {
    case 'sesion.iniciada': {
      const equipo = await read.dispositivo(event.deviceId);
      if (!equipo) return { effects: [], rejections: [] };
      return {
        effects: [
          { kind: 'dispositivo.patch', id: equipo.id, rev: orderKey(event), patch: { usuarioActual: event.actorId } },
        ],
        rejections: [],
      };
    }
    case 'sesion.pin_incorrecto':
      return { effects: [], rejections: [] };
    default:
      return null;
  }
}
